module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center mt-8 border-b border-gray-200"
  }, [(_vm.team_session == 1) ? _c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Trafico Mensual\n      ")]) : _c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Trafico Semanal\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n            Ver todas las cuentas\n          ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n            Ver solo una cuenta\n          ")]), _vm._v("  \n          "), _c('div', {
    staticClass: "mr-3"
  }, [_vm._v("Fechas:")]), _vm._v(" "), _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('minus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-left',
      "classname": 'w-5'
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button mr-1 mb-2 mt-2 bg-theme-1 text-white courser-not"
  }, [_vm._v("\n            " + _vm._s(_vm.firstday.toISOString().slice(0, 10)) + " - " + _vm._s(_vm.lastday.toISOString().slice(0, 10)) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button inline-flex button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('plus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-right',
      "classname": 'w-5'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [(_vm.team_session == 1) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box mt-4 p-2"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id
    }, _vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id && project.hours > 1) ? _c('div', [(project.hours - sum.total < 0) ? _c('div', {
        staticClass: "flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
        attrs: {
          "role": "alert"
        }
      }, [_c('svg', {
        staticClass: "w-5 h-5 inline mr-3",
        attrs: {
          "fill": "currentColor",
          "viewBox": "0 0 20 20",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "font-medium"
      }, [_vm._v(_vm._s(project.name) + " - " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix))]), _vm._v(" excedió el número de horas asignadas.\n                      ")])]) : _vm._e()]) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return (project.account_id == _vm.account_session || _vm.account_session == null) ? _c('div', {
      staticClass: "intro-y box mt-1"
    }, [_c('div', {
      staticClass: "flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200"
    }, [_c('h2', {
      staticClass: "font-medium text-base mr-auto",
      class: [
        project.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v("\n                    " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(project.hours - sum.total)))])]) : _vm._e()
    }), _vm._v("\n                       Horas Disponibles\n                    ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not"
    }, [_vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(sum.total)))]) : _vm._e()
    }), _vm._v(" /\n                       "), (project.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(project.hours)))]) : _vm._e(), _vm._v(" Horas\n                    ")], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "p-5",
      attrs: {
        "id": "bordered-table"
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      staticClass: "overflow-x-auto"
    }, [_c('table', {
      staticClass: "table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
      return (task.project_id == project.id) ? _c('tr', {
        class: {
          'tr-green': task.state_id == 4
        }
      }, [_c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [(task.user_id) ? _c('span', [_vm._v(_vm._s(task.user_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_c('button', {
        staticClass: "button button--sm w-24 text-white",
        class: _vm.dateClass(task)
      }, [_vm._v(_vm._s(task.date))])]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.state_name))])]) : _vm._e()
    }), 0)])])])])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box p-2 mt-4"
  }, _vm._l((_vm.user.accounts), function(account) {
    return _c('div', {
      key: account.id
    }, _vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', _vm._l((_vm.filteredHours), function(hour) {
        return (hour.account_id == account.id) ? _c('span', [(hour.hours - sum.total < 0) ? _c('div', {
          staticClass: "flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
          attrs: {
            "role": "alert"
          }
        }, [_c('svg', {
          staticClass: "w-5 h-5 inline mr-3",
          attrs: {
            "fill": "currentColor",
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
            "clip-rule": "evenodd"
          }
        })]), _vm._v(" "), _c('div', [_c('span', {
          staticClass: "font-medium"
        }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))]), _vm._v(" excedió el número de horas asignadas.\n                    ")])]) : _vm._e()]) : _vm._e()
      }), 0) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), _vm._l((_vm.user.accounts), function(account) {
    return (account.id == _vm.account_session || _vm.account_session == null) ? _c('div', {
      staticClass: "intro-y box mt-1"
    }, [_c('div', {
      staticClass: "flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200"
    }, [_c('h2', {
      staticClass: "font-medium text-base mr-auto"
    }, [_vm._v("\n                  " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', _vm._l((_vm.filteredHours), function(hour) {
        return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(hour.hours - sum.total)))]) : _vm._e()
      }), 0) : _vm._e()
    }), _vm._v("\n                     Horas Disponibles\n                  ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not"
    }, [_vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(sum.total)))]) : _vm._e()
    }), _vm._v(" /\n                     "), _vm._l((_vm.filteredHours), function(hour) {
      return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(hour.hours)))]) : _vm._e()
    }), _vm._v(" Horas\n                  ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.filteredHours), function(hour) {
      return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")((hour.hours) / 5)))]) : _vm._e()
    }), _vm._v(" Diarias\n                  ")], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "p-5",
      attrs: {
        "id": "bordered-table"
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      staticClass: "overflow-x-auto"
    }, [_c('table', {
      staticClass: "table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
      return (task.campaign_attribute.project_account_id == account.id) ? _c('tr', {
        class: {
          'tr-green': task.state_id == 4
        }
      }, [_c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(_vm._f("limit")(task.name)))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v("\n                                      " + _vm._s(task.state_name) + " "), _c('br'), _vm._v(" "), (task.user_id) ? _c('span', [_vm._v(_vm._s(task.user_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_c('button', {
        staticClass: "button button--sm w-24 text-white",
        class: _vm.dateClass(task)
      }, [_vm._v(_vm._s(task.date))])]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [(task.state_id != 4) ? _c('a', {
        staticClass: "cursor-pointer flex items-center mr-3",
        on: {
          "click": function($event) {
            return _vm.viewAccountTask(task)
          }
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "edit",
          "classname": "w-4 h-4 mr-2"
        }
      }), _vm._v(" Editar\n                                      ")], 1) : _vm._e()])]) : _vm._e()
    }), 0)])])])])]) : _vm._e()
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Asignada a")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("No. Horas")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Fecha Entrega")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Estado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("No. Horas")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Fecha Entrega")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Acciones")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea676cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/calendar/Week.vue
// module id = 485
// module chunks = 1